import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { buildJournalItemUrl } from 'shared/helpers/urlBuilder';
import NewsItem, { TYPES } from 'shared/components/NewsItem/NewsItem';
import Paginate from 'desktop/components/Paginate/Paginate';
import s from './NewsAndPromotions.css';

class NewsAndPromotions extends React.Component {
  static propTypes = {
    news: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    title: PropTypes.string.isRequired,
    page: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    query: PropTypes.shape().isRequired,
    url: PropTypes.string.isRequired,
  };

  render() {
    const { news, title, page, pageCount, url, query } = this.props;

    return (
      <div>
        <h1 className={s.title}>
          <FormattedMessage id="Новости и акции" /> {` ${title}`}
        </h1>
        <div className={s.root}>
          <div>
            {!news.length &&
              <p>
                <FormattedMessage id="Нет новостей" />
              </p>}
            {news.map(({ id, slug, ...newsProps }) =>
              <NewsItem
                className={s.newsItemLayziLoad}
                type={TYPES.LIST}
                key={id}
                link={buildJournalItemUrl(slug)}
                {...newsProps}
              />,
            )}
          </div>
          {pageCount > 1 &&
            <Paginate pageCount={pageCount} initialPage={page} url={url} query={query} />}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(NewsAndPromotions);



// WEBPACK FOOTER //
// ./src/desktop/routes/dealer/components/NewsAndPromotions/NewsAndPromotions.js